/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import { Link } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { FC } from 'react'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import {
  findAllPauseTokens,
  findAllPauseTokensVariables,
  findAllPauseTokens_findAllPauseToken_items as PauseToken,
} from '__generatedTypes__/findAllPauseTokens'
import Table, { TableProps } from 'components/Table'
import { cmsRoutes, useLink } from 'routes/cmsRoutes'
import { FIND_ALL_PAUSE_TOKENS } from 'queries/pauseTokens'
import Loader from 'components/Loader'
import { convertToDollars, priceFormatter } from 'utils/priceFormatter'
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import * as classes from './styles'

type Props = {
  platform: Platform
}

export const List: FC<Props> = ({ platform }) => {
  const { getLink } = useLink()

  const { data, loading } = useQuery<findAllPauseTokens, findAllPauseTokensVariables>(FIND_ALL_PAUSE_TOKENS, {
    fetchPolicy: 'network-only',
    variables: {
      query: {
        where: {
          platform: {
            id: platform.id,
          },
        },
      },
    },
  })

  if (loading) {
    return <Loader />
  }

  const productColumns: TableProps<PauseToken>['columns'] = [
    {
      title: 'Name',
      renderCell: ({ name }) => <Typography variant="body2">{name}</Typography>,
      flex: '2',
    },
    {
      title: 'Status',
      renderCell: ({ status }) => <Typography variant="body2">{status}</Typography>,
      flex: '1',
    },
    {
      title: 'Price',
      renderCell: ({ price }) => (
        <Typography variant="body2">{priceFormatter.format(convertToDollars(price))}</Typography>
      ),
      flex: '1',
    },
    {
      title: 'Active',
      renderCell: ({ active }) => <Typography variant="body2">{active}</Typography>,
      flex: '1',
    },
    {
      renderCell: ({ id }) => (
        <Link
          to={getLink(cmsRoutes.PRODUCTS_PAUSE_TOKEN_EDIT, {
            id,
          })}
        >
          <IconButton size="small" css={classes.link}>
            <EditIcon />
          </IconButton>
        </Link>
      ),
      flex: '0 1 44px',
    },
  ]

  const items = data?.findAllPauseToken?.items || []

  return <Table columns={productColumns} items={items} />
}
